<template>
  <div class="mainHome mx-auto my-5">
    <!--影像推荐-->
    <div class="mainHome-example">
      <div class="mainHome-example-imageList">
        <div id="mainHome-example-imageList-scrollArea">
          <div @click="exampleImageSelectedIndex = index;" v-for="(item,index) in exampleImage" :key="index" class="pa-0"
               style="position:relative;width:180px;height:154px;display:inline-block;margin:0 17.5px;cursor:pointer;"
               :style="{'border-bottom':exampleImageSelectedIndex === index ? '3px solid #2A82E4' : '3px solid transparent'}">
            <div style="width:100%;height:101px;background-position: center;background-size:cover;"
                 :style="{'background-image':'url(' + item.thumb + ')'}">
            </div>
            <p :style="{'color':exampleImageSelectedIndex === index ? '#2A82E4' : '#000000'}"
               style="height:48px;white-space: normal;text-align:center;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">
              <span style="font-weight:bold;">[{{getTypeText(item.type)}}]</span>
              {{item.title}}
            </p>
            <img v-show="item.logo!==''" :src="item.logo" style="position:absolute;top:0;left:0;width:35px;height:35px;" />
          </div>
        </div>
      </div>
      <div id="exampleImageCarouselArea" class="mainHome-example-carouselArea">
        <v-carousel v-model="exampleImageSelectedIndex" cycle interval="3000" hide-delimiters :height="exampleImageCarouselHeight + 'px'">
          <v-carousel-item @click="intoGlobeDetailPage(item)" v-for="(item,index) in exampleImage" :key="index">
            <div style="width:100%;height:calc(100%);background-position: center;background-size:cover;"
                 :style="{'background-image':'url(' + item.jpgLink + ')'}">
            </div>
            <div style="position:absolute;bottom:0;left:0;width:100%;height:26px;background:rgba(0, 0, 0, 0.7);display:flex;align-items: center;color:#ffffff;font-size:14px;" class="px-5">
              <p>{{item.title}}</p>
              <v-spacer></v-spacer>
              <p>{{getTypeText(item.type)}} | {{item.fLabel}}<span v-show="item.cLabel !== ''"> , {{item.cLabel}}</span> <span v-show="item.satellite!==''">| {{item.satellite}}</span><span v-show="item.shootTime!==''"> | {{item.shootTime}} </span>|</p>
              <p>&nbsp;吉林一号·共生地球</p>
            </div>
          </v-carousel-item>
<!--          <v-btn @click="intoGlobe" large dark color="#1976D2" width="190" style="position:absolute;bottom:46px;right:30px;">-->
<!--            <span style="font-size:20px;">影像中心</span>-->
<!--          </v-btn>-->
        </v-carousel>

      </div>

    </div>
    <!--近期创作-->
    <div class="mainHome-recentCreation ml-6">
      <div style="width:100%;height:60px;display:flex;" class="px-6">
        <p style="font-size:20px;font-weight:bold;line-height:60px;">近期创作</p>
        <v-spacer></v-spacer>
        <p @click="intoCreationManage" v-if="creationList.length !== 0" style="color:#808080;line-height:60px;cursor:pointer;">更多</p>
      </div>
      <!--无创作-->
      <div v-if="creationList.length === 0" style="width:100%;height:338px;background:#ffffff;text-align:center;padding-top:84px;">
        <p style="font-size:43px;color:#e5e5e5;" class="iconfontFamily">&#xe618;</p>
        <p class="mt-6">当前暂无近期数据，开始进行首次<span @click="intoCreate" style="color:#1976D2;cursor:pointer;">内容创作</span>吧~</p>
      </div>
      <!--创作项-->
      <creation-item v-for="(item,index) in creationList" :key="index" :creationInfo="item"
                     @saveAsDraftSuccess="saveAsDraftSuccess" @deleteOKFun="deleteOKFun"
                     style="box-shadow:none;border-top:2px solid rgb(229, 229, 229)"></creation-item>
    </div>
    <!--遇到问题-->
    <div @click="$store.commit('setShowFeedBackDialog',true)" class="mainHome-feedback">
      <p style="line-height:22px;margin-top:20px;">遇到问题</p>
    </div>

    <feed-back-dialog></feed-back-dialog>

  </div>

</template>

<script>
import CreationItem from '/src/components/creation_item/CreationItem';
import FeedBackDialog from "@/views/home/feed_back/FeedBackDialog";

export default {
  name: "MainHome",
  components: {
    CreationItem,FeedBackDialog
  },
  data(){
    return{
      //示例影像库信息
      exampleImage:[],
      exampleImageSelectedIndex:0,
      //影像轮播图高度
      exampleImageCarouselHeight:0,

      //影像库类型
      imageTypeList:[],

      //近期创作
      creationList:[],

    }



  },
  computed:{
    getTypeText(){
      return function(type){
        for(let i=0;i<this.imageTypeList.length;i++){
          if(this.imageTypeList[i].typeId === type){
            return this.imageTypeList[i].typeName;
          }
        }
      }
    }

  },
  watch:{
    exampleImageSelectedIndex(){
      if(180 * this.exampleImageSelectedIndex < 1180){
        document.getElementById("mainHome-example-imageList-scrollArea").scrollTo(212 * this.exampleImageSelectedIndex,0)
      }
    }

  },
  methods:{
    //初始化轮播图组件高度
    indexExampleImageCarouselHeight(){
      this.changeExampleImageCarouselHeight();
      // window.addEventListener('resize',this.changeExampleImageCarouselHeight);
    },
    changeExampleImageCarouselHeight(){
      this.exampleImageCarouselHeight = document.getElementById("exampleImageCarouselArea").offsetHeight - 90
    },

    //获取影像库推荐
    getExampleImageList(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection/getRecommendList",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.exampleImage = resultData.data;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },
    //获取影像集type数字和文字的对应
    getImageType(){
      //类别序号转对应文字
      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection-type/getList",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.imageTypeList = resultData.data
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },



    //获取最近创作
    getRecentCreation(){
      this.$axios({
        method:"get",
        url:"/authorApi/main-info/getMainInfoList",
        params:{
          progressStatus:-1,
          curPageNum:1,
          maxResultNum:2,
          searchContent:""
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.creationList = resultData.data.mainInfoDtoList;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },


    //进入创作管理
    intoCreationManage(){
      this.$store.state.homeLeftBarSelectedIndex = 2;
    },
    //进入内容创作
    intoCreate(){
      this.$store.state.homeLeftBarSelectedIndex = 1;
    },
    // //进入球页面
    // intoGlobe(){
    //   this.$router.push({
    //     path:'/globe'
    //   })
    // },
    //进入影像详情页
    intoGlobeDetailPage(item){
      let routeData = this.$router.resolve({
        path: '/productDetails', query: { mainId: item.mainId }
      });
      window.open(routeData.href, '_blank');
    },


    //另存草稿成功
    saveAsDraftSuccess(param){
      this.getRecentCreation();
    },
    //近期创作删除成功
    deleteOKFun(){
      this.getRecentCreation();
    }


  },
  mounted(){
    this.getImageType();
    this.indexExampleImageCarouselHeight();
    this.getExampleImageList();
    this.getRecentCreation();

  },
  destroyed() {
    // window.removeEventListener('resize',this.changeExampleImageCarouselHeight);
  }


}
</script>

<style scoped>
.mainHome{
  position:relative;
  width:1604px;
  height:calc(100% - 40px);
  display:flex;
}
.mainHome-example{
  /*min-width:1180px;*/
  /*width: calc(100% - 424px);*/
  width: 1180px;
  height:100%;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  display:inline-block;
  vertical-align: top;
}
.mainHome-example-imageList{
  background:#ffffff;
  padding:24px 52.5px 0 52.5px;
}
#mainHome-example-imageList-scrollArea{
  width:100%;
  height:158px;
  overflow-x:hidden;
  overflow-y:hidden;
  white-space: nowrap;
}

#mainHome-example-imageList-scrollArea::-webkit-scrollbar{
  height:4px;
}
#mainHome-example-imageList-scrollArea::-webkit-scrollbar-track-piece{
  -webkit-border-radius:0;
}
#mainHome-example-imageList-scrollArea::-webkit-scrollbar-thumb{
  background-color: rgb(150,150,150);
  -webkit-border-radius:1px;
  border: 1px solid rgb(150,150,150);
}


.mainHome-example-carouselArea{
  height:calc(100% - 154px - 24px - 2px);
  background:#ffffff;
  padding:24px 70px 62px 70px;
  margin-top:2px;
}

.mainHome-recentCreation{
  width:400px;
  height:62px;
  background:#ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  display:inline-block;
  vertical-align: top;
}

.mainHome-feedback{
  position:fixed;
  top:75%;
  /*right:-40px;*/
  right:0;
  width:45px;
  height:80px;
  background:#ffffff;
  text-align:center;
  cursor:pointer;
}


</style>
